﻿(function ($) {

    //Attach this new method to jQuery
    $.fn.extend({

        //This is where you write your plugin's name
        AjaxScroller: function (options) {

            //Set the default values, use comma to separate the settings, example:
            var _defaults = {
                PreviousBtn: '',
                NextBtn: '',
                SearchBtn: '',
                NextBtnTextFormat: '',
                NextBtnOnLoadingHtml: '',
                ServiceUrl: '',
                DataJson: null,
                TemplateId: null,
                TemplateResetAttributes: null,
                Params: '',
                PageCount: -1,
                PageNumber: 1,
                ItemsPerShow: 1,
                FullAjax: false,
                AutoScroll: false,
                AutoScrollSpeed: 0,
                Transition: 'FadeIn', /* FadeIn, Append */
                ResultType: 'json', /* json,html */
                EnableCache: true,
                DisableShowIfNotNull: false,
                OnlyShowFirstPage: false,
                BeforePrevious: null,
                AfterPrevious: null,
                BeforeNext: null,
                AfterNext: null,
                ValidateBeforeLoad: null,
                BeforeLoad: null,
                AfterLoad: null,
                AfterInvoke: null,
                AfterResultInvoke: null
            }

            var _options = $.extend(_defaults, options);

            var _preBtn = null;
            var _nxtBtn = null;
            var _template = null;
            var _scroller = null;

            var _resposeCache = {};

            var _ResultCount = -1;
            var _PageCount = -1;
            var _PageNumber = 1;
            var _PageStartIndex = -1;
            var _PageEndIndex = -1;

            var _request = null;
            var _this = null;

            //Iterate over the current set of matched elements
            return this.each(function () {
                Init($(this));
            });

            function Init(obj) {
                _PageCount = _options.PageCount;

                // Initiating controls and template
                _preBtn = $('#' + _options.PreviousBtn);
                _nxtBtn = $('#' + _options.NextBtn);
                _schBtn = $('#' + _options.SearchBtn);

                _scroller = $(obj);

                if (_options.TemplateId == null || _options.TemplateId == undefined || _options.TemplateId == '') {
                    _template = $($(_scroller).find('*[tmpl="AjaxScrollerTemplate"]:first'), obj);
                } else {
                    _template = $('#' + _options.TemplateId);
                }

                // Activating Previous Button
                $(_preBtn).unbind("click");
                $(_preBtn).attr({
                    href: 'javascript:void(0);'
                }).click(function () {
                    LoadPrevious();
                });

                // Activating Next Button
                $(_nxtBtn).unbind("click");
                $(_nxtBtn).attr({
                    href: 'javascript:void(0);'
                }).click(function () {
                    LoadNext();
                });

                // Activating Search Button
                $(_schBtn).unbind("click");
                $(_schBtn).attr({
                    href: 'javascript:void(0);'
                }).click(function () {
                    _scroller.html('');
                    _options.Params = $(_schBtn).attr('data-urlQuery');
                    _options.PageNumber = 1;
                    Bind();
                });

                ShowHideControls(_options);

                if (_options.FullAjax) {
                    Bind();
                }
                if (_options.AutoScroll) setTimeout(function () { LoadNext(); }, _options.AutoScrollSpeed);
            }

            function ShowHideControls(optn) {
                if (optn == null) {
                    if (_PageNumber >= _PageCount) _PageNumber = 1;
                } else {
                    if (optn.PageNumber == 1) $(_preBtn).hide(); else $(_preBtn).show();
                    if (optn.PageNumber >= optn.PageCount) $(_nxtBtn).hide(); else $(_nxtBtn).show();
                }
            }

            function Clear() {
                if (_options.ResultType == 'json') {
                    $(_scroller).find('*[tmpl="AjaxScrollerTemplate"]').remove();
                }
                else {
                    $(_scroller).html('');
                }
            }

            function ShowItems(html, data) {
                if (_options.AfterResultInvoke) {
                    _options.AfterResultInvoke(_options, data);
                }

                if (_options.AfterHtmlResultInvoke) {
                    _options.AfterHtmlResultInvoke(_options, data, html);
                }

                if (_options.OnlyShowFirstPage && _options.PageNumber > 1) {
                    return;
                }

                var _htmlTpml = $('<div></div>').append(html);
                $(_htmlTpml).find('*[tmplLoader="false"]').each(function () { $(this).show(); });
                $(_htmlTpml).find('*[tmplLoader="true"]').each(function () { $(this).hide(); });

                if (_options.Transition == 'FadeIn') {
                    $(_scroller).fadeOut('slow', function () {
                        Clear();
                        $(_scroller).append($(_htmlTpml).html());
                        $(_scroller).fadeIn('slow', function () {
                            if (_options.AfterLoad) {
                                _options.AfterLoad(_options, data);
                            }
                        });
                    });
                }
                else if (_options.Transition == 'Append') {
                    $(_scroller).append($(_htmlTpml).html());
                    if (_options.AfterLoad) {
                        _options.AfterLoad(_options, data);
                    }
                }

                if (data != null && data != undefined && data != '' && 
                    _options.NextBtnTextFormat != null && _options.NextBtnTextFormat != undefined && _options.NextBtnTextFormat != '') {
                    var _iBalCount = data.ResultCount - (data.PageNumber * data.PageSize);
                    $(_nxtBtn).html(_options.NextBtnTextFormat.replace('{BALCOUNT}', _iBalCount));
                }
                

                ShowHideControls(data);
            }

            function LoadPrevious() {
                if (_options.BeforePrevious != null) _options.BeforePrevious(_options);

                if (parseInt(_options.PageNumber) == 1) _options.PageNumber = _PageCount + 1;
                if (parseInt(_options.PageNumber) == -1) _options.PageNumber = 2;

                _options.PageNumber--;
                Bind();

                if (_options.AfterPrevious != null) _options.AfterPrevious(_options);
            }

            function LoadNext() {
                if (_options.BeforeNext != null) _options.BeforeNext(_options);

                if (parseInt(_options.PageNumber) == parseInt(_PageCount)) _options.PageNumber = 0;
                if (parseInt(_options.PageNumber) == -1) _options.PageNumber = 0;

                _options.PageNumber++;

                if (_options.NextBtnOnLoadingHtml != '') $(_nxtBtn).html(_options.NextBtnOnLoadingHtml);

                Bind();

                if (_options.AutoScroll) setTimeout(function () { LoadNext(); }, _options.AutoScrollSpeed);

                if (_options.AfterNext != null) _options.AfterNext(_options);
            }

            function Bind() {
                $(_scroller).addClass('AgoraAjaxScrollerIsLoading');
                if (_options.BeforeLoad != null) _options.BeforeLoad();
                if (_options.ValidateBeforeLoad != null && _options.ValidateBeforeLoad() == true) return;

                if (_options.EnableCache) {
                    var _cacheKey = _options.Params + '&pageSize=' + _options.ItemsPerShow + '&pageNum=' + _options.PageNumber;
                    if (_resposeCache[_cacheKey]) {
                        ShowItems(_resposeCache[_cacheKey]);
                        return;
                    }
                }

                if (_options.DataJson != null) {
                    //applyTemplate(_options.DataJson);
                    applyTemplate(_options.DataJson);
                    return;
                }

                _request = $.ajax({
                    type: 'POST',
                    url: _options.ServiceUrl,
                    data: _options.Params + '&pageSize=' + _options.ItemsPerShow + '&pageNum=' + _options.PageNumber,
                    dataType: 'json',
                    success: function (data) {

                        //applyTemplate(_options.DataJson);
                        var _responseHTML = applyTemplate(data);
                        
                        if (_options.EnableCache) { _resposeCache[_cacheKey] = _responseHTML; }

                        if (_options.EnableCache) { ShowItems(_resposeCache[_cacheKey], data); } else { ShowItems(_responseHTML, data); }
                    },
                    statusCode: {
                        404: function () {
                            console.log('Service (agoraGet) not found!');
                        }
                    }
                });

                if (_options.AfterInvoke != null) _options.AfterInvoke(_request);
                $(_scroller).removeClass('AgoraAjaxScrollerIsLoading');
            }

            function applyTemplate(data) {
                var _tmpl = $('<div></div>').append($(_template).clone());
                var _responseHTML = '';
                var _templateResetAttributes = _options.TemplateResetAttributes != null ? _options.TemplateResetAttributes.split(',') : [];
                for (i = 0; i < _templateResetAttributes.length && $(_tmpl).first() != null && $(_tmpl).first() != undefined; i++) {
                    $(_tmpl).first().removeAttr(_templateResetAttributes[i]);
                }
                if (_options.ResultType == 'json') {

                    if (data.Items != undefined && data.Items.length != undefined && data.Items.length > 0) {
                        $.each(data.Items, function (i, item) {
                            var _tmpValue = '';
                            $(_tmpl).find('*[tmplValId]').each(function () {
                               
                                //reset the css
                                if (_options.DisableShowIfNotNull) { $(this).css("display", ""); }

                                if ($(this).attr("title") != undefined && $(this).attr("title-tmpl") != undefined && $(this).attr("title-tmpl").indexOf('FORMAT::') > -1) {
                                    var _valueFormat = $(this).attr("title-tmpl").replace('FORMAT::', '');
                                    var _valueIds = _valueFormat.split('{');
                                    for (i = 0; i < _valueIds.length; i++) {
                                        if (_valueIds[i].indexOf('}') > -1) {
                                            var _valueId = _valueIds[i].substring(0, _valueIds[i].indexOf('}'));
                                            _tempValue = GetJsonValue(item, _valueId);
                                            console.log(item);
                                            _valueFormat = _valueFormat.replace('{' + _valueId + '}', _tempValue);
                                        }
                                    }
                                    $(this).attr('title', _valueFormat);
                                }

                                if ($(this).attr("tmplValType") == undefined || $(this).attr("tmplValType") == '') {
                                    _tempValue = GetJsonValue(item, $(this).attr("tmplValId"));

                                    if (_tempValue != '' && _tempValue != null && _tempValue != undefined) {
                                        $(this).html(_tempValue);
                                        if (!_options.DisableShowIfNotNull) $(this).show();
                                    }
                                    else {
                                        $(this).hide();
                                    }
                                }
                                else if ($(this).attr("tmplValId").indexOf('FORMAT::') > -1) {
                                    var _valueFormat = $(this).attr("tmplValId").replace('FORMAT::', '');
                                    var _valueIds = _valueFormat.split('{');
                                    var _anyValueAvailable = false;
                                    for (i = 0; i < _valueIds.length; i++) {
                                        if (_valueIds[i].indexOf('}') > -1) {
                                            var _valueId = _valueIds[i].substring(0, _valueIds[i].indexOf('}'));
                                            _tempValue = GetJsonValue(item, _valueId);
                                            _valueFormat = _valueFormat.replace('{' + _valueId + '}', _tempValue);

                                            if (_tempValue != '' && _tempValue != null && _tempValue != undefined) {
                                                _anyValueAvailable = true;
                                            }
                                        }
                                    }

                                    if (!_anyValueAvailable) {
                                        $(this).hide();
                                    } else {
                                        if (!_options.DisableShowIfNotNull) $(this).show();
                                    }

                                    if ($(this).attr("tmplValType").indexOf('html') > -1) $(this).html(_valueFormat);
                                    else $(this).attr($(this).attr("tmplValType"), _valueFormat);
                                }
                                else {
                                    _tempValue = GetJsonValue(item, $(this).attr("tmplValId"));
                                    if (_tempValue != '' && _tempValue != null && _tempValue != undefined) {
                                        if ($(this).attr("tmplValType").indexOf('html') > -1) $(this).html((($(this).attr('tmplExtra')) ? $(this).attr('tmplExtra') : '') + GetJsonValue(item, $(this).attr("tmplValId")) + (($(this).attr('tmplExtraAfter')) ? $(this).attr('tmplExtraAfter') : ''));
                                        else $(this).attr($(this).attr("tmplValType"), (($(this).attr('tmplExtra')) ? $(this).attr('tmplExtra') : '') + GetJsonValue(item, $(this).attr("tmplValId")) + (($(this).attr('tmplExtraAfter')) ? $(this).attr('tmplExtraAfter') : ''));
                                        if (!_options.DisableShowIfNotNull) $(this).show();
                                    }
                                    else {
                                        $(this).hide();
                                    }
                                }
                            });


                            if (_options.OnBindItem != null) _options.OnBindItem($(_tmpl).html());

                            _responseHTML += $(_tmpl).html();
                        });
                    }
                    else {
                        _responseHTML = '';
                        _ResultCount = data.ResultCount;
                        _PageCount = data.PageCount;
                        _PageNumber = data.PageNumber;
                        _PageStartIndex = data.PageStartIndex;
                        _PageEndIndex = data.PageEndIndex;
                    }

                    _ResultCount = data.ResultCount;
                    _PageCount = data.PageCount;
                    _PageStartIndex = data.PageStartIndex;
                    _PageEndIndex = data.PageEndIndex;
                    _options.ItemsPerShow = data.PageSize;
                    _options.PageNumber = data.PageNumber;
                }
                else {// if(_options.ResultType == 'html')
                    _responseHTML = data;
                    _ResultCount = ($(data).find('span[tmplDataItem="ResultCount"]').html() ? parseInt($(data).find('span[tmplDataItem="ResultCount"]').html()) : 0);
                    _PageCount = ($(data).find('span[tmplDataItem="PageCount"]').html() ? parseInt($(data).find('span[tmplDataItem="PageCount"]').html()) : 0);
                    _PageNumber = ($(data).find('span[tmplDataItem="PageNumber"]').html() ? parseInt($(data).find('span[tmplDataItem="PageNumber"]').html()) : 0);
                    _PageStartIndex = ($(data).find('span[tmplDataItem="PageStartIndex"]').html() ? parseInt($(data).find('span[tmplDataItem="PageStartIndex"]').html()) : 0);
                    _PageEndIndex = ($(data).find('span[tmplDataItem="PageEndIndex"]').html() ? parseInt($(data).find('span[tmplDataItem="PageEndIndex"]').html()) : 0);
                }
                return _responseHTML;
            }

            this.SetDataJson = function (data) {
                _options.DataJson = data;
                if (_options.DataJson != null)
                    applyTemplate(_options.DataJson);
            };

            function GetJsonValue(obj, attribute) {
                if (attribute.indexOf('.') > -1) {
                    attributes = attribute.split('.');
                    if (attributes.length == 2) {
                        return obj[attributes[0]][attributes[1]];
                    }
                    else if (attributes.length == 3) {
                        return obj[attributes[0]][attributes[1]][attributes[2]];
                    }
                    else if (attributes.length == 4) {
                        return obj[attributes[0]][attributes[1]][attributes[2]][attributes[3]];
                    }
                    else if (attributes.length == 5) {
                        return obj[attributes[0]][attributes[1]][attributes[2]][attributes[3]][attributes[4]];
                    }
                }
                else {
                    return obj[attribute];
                }
            }
        }
    });
})(jQuery);